<micro-select-combo #sel
                    [placeholder]="placeholder"
                    routerBase="contactGroups"
                    [mode]="mode"
                    [(id)]="contactGroupId"
                    (idChange)="change($event)"
                    [options]="options"
                    [required]="required"
                    [disabled]="disabled"
                    [sizeDynamically]="sizeDynamically"
                    [allLabel]="allLabel"
                    [jump]="jump">
</micro-select-combo>
